import Vue from 'vue';
import { union } from 'lodash'
import { normalize, denormalize } from 'normalizr';
import normalizrSchemas from '../normalizrSchema'

const entityListsMap = {

};

let updateListsOfEntities = (state, { entityType, id }, add = true) => {
  let entityLists = entityListsMap[entityType];
  if (entityLists) {
    for (let { parentEntityType, listKey, parentIdKey } of entityLists) {
      let entity = state.entities[entityType][id];
      if (entity) {
        let parentId = entity[parentIdKey];
        let parentEntity = state.entities[parentEntityType][parentId];
        if (parentEntity) {
          if (add) {
            Vue.set(parentEntity, listKey, union(parentEntity[listKey], [id]));
          } else {
            parentEntity[listKey] = parentEntity[listKey].filter(item => {
              return item !== id;
            })
          }
        }
      }
    }
  }
}

export default {

  UPDATE_ENTITIES(state, { entities, list, listEntitiesType, replace = false }) {
    for (let type in entities) {
      for (let entity in entities[type]) {
        const oldObj = state.entities[type][entity] || {};
        const newObj = Object.assign({}, oldObj, entities[type][entity]);
        Vue.set(state.entities[type], entity, newObj);
        updateListsOfEntities(state, { entityType: listEntitiesType, id: newObj._id }, true);
      }
    }

    if (state.entities[listEntitiesType + 'List']) {
      if (replace) {
        state.entities[listEntitiesType + 'List'] = [];
      }
      Vue.set(state.entities, listEntitiesType + 'List', union(state.entities[listEntitiesType + 'List'], list));
    }
  },

  REMOVE_ENTITY(state, { entityType, id }) {
    updateListsOfEntities(state, { entityType, id }, false);
    let array = state.entities[entityType + 'List'];
    if (Array.isArray(array)) {
      state.entities[entityType + 'List'] = array.filter(item => {
        return item !== id;
      })
    }
    if (state.entities[entityType][id]) {
      Vue.delete(state.entities[entityType], id);
    }
  },

  ADD_EDITABLE_ENTITY(state, { schema, entity }) {
    let systemSetupEntitiesTypes = [
      'taskTypes',
    ];
    for (let type of systemSetupEntitiesTypes) {
      for (let key of Object.keys(state.entities[type])) {
        let clonedValues = Object.assign({}, state.entities[type][key]);
        Vue.set(state.editableEntities[type], key, clonedValues);
      }
    }

    const denormalizedData = denormalize(entity, normalizrSchemas[schema], state.entities);
    const normalizedData = normalize(denormalizedData, normalizrSchemas[schema]);
    
    for (let type in normalizedData.entities) {
      for (let entity in normalizedData.entities[type]) {
        const oldObj = state.editableEntities[type][entity] || {};
        const newObj = Object.assign(oldObj, normalizedData.entities[type][entity]);
        Vue.set(state.editableEntities[type], entity, newObj)
      }
    }
  },

  UPDATE_ENTITY(state, { entityType, id, updatedFields, bucket = 'editableEntities' }) {
    Vue.set(state[bucket][entityType], id, Object.assign({}, state.editableEntities[entityType][id], updatedFields));
  },

  REMOVE_EDITABLE_ENTITY(state, { entityType, id }) {
    delete state.editableEntities[entityType][id];
  },

  REMOVE_EDITABLE_ENTITIES(state) {
    for (let key of Object.keys(state.editableEntities)) {
      state.editableEntities[key] = {};
    }
  },

  SET_ENTITY_EDIT_DATA: (state, payload) => {
    state.entityEditData = payload;
  },

  //*** new ***/
  OPEN_ENTITY: (state, payload) => {
    state.entityEditData = payload;
  },

  TOGGLE_STORE_TRANSFER_DIALOG: (state, payload) => {
    state.storeTransferDialog = payload;
  },

  TOGGLE_BULK_DEVICES_DIALOG: (state, payload) => {
    state.bulkDevicesDialog = payload;
  },

  TOGGLE_DELIVERY_HAS_ARRIVED_DIALOG: (state, payload) => {
    state.deliveryHasArrivedDialog = payload;
  },

  TOGGLE_BOOK_OUT_DIALOG: (state, payload) => {
    state.bookOutDialog = payload;
  },

  TOGGLE_CHECK_IN_DIALOG: (state, payload) => {
    state.checkInDialog = payload;
  },

  TOGGLE_CANCEL_ORDER_DIALOG: (state, payload) => {
    state.cancelOrderDialog = payload;
  },

  TOGGLE_FINALIZE_DIALOG: (state, payload) => {
    state.finalizeDialog = payload;
  },

  TOGGLE_SEND_EMAIL_DIALOG: (state, payload) => {
    state.sendEmailDialog = payload;
  },

  TOGGLE_SEND_SMS_DIALOG: (state, payload) => {
    state.sendSmsDialog = payload;
  },

  TOGGLE_PAYMENT_DIALOG: (state, payload) => {
    state.paymentDialog = payload;
  },

  TOGGLE_ENTITY_EDIT_DIALOG: (state, payload) => {
    state.entityEditDialog = payload;
  },

  TOGGLE_NIGHT_MODE: (state, payload) => {
    state.nightMode = payload;
  },
  TOGGLE_MAIN_MENU: (state, payload) => {
    state.isMainMenuActive = payload;
  },
  SET_MAIN_MENU_MINI_VARIANT: (state, payload) => {
    state.mainMenuMiniVariant = payload;
  },
  SET_SHOULD_SHOW_MAIN_MENU_AUTOMATICALLY: (state, payload) => {
    state.shouldShowMainMenuAutomatically = payload;
  },
  SET_SNACKBAR: (state, payload) => {
    state.snackbar = payload;
  },
  SET_SNACKBAR_DATA: (state, payload) => {
    state.snackbarData = payload;
  },
  SET_CONTACT_DETAIL_TYPES: (state, payload) => {
    state.contactDetailTypes = payload;
  },
  SET_FETCHING: (state, payload) => {
    state.fetching = payload;
  },
};